export function getPlatformLabel(platform: string): string {
  const labels: Record<string, string> = {
    OPENCLAW: 'openClaw',
    CLAUDE_COWORK: 'Claude CoWork',
    CODEX_APP: 'Codex App',
    GENERIC: 'Generic (All Agents)',
    OTHER: 'Other',
  }
  return labels[platform] || platform
}

export function getCategoryLabel(category: string): string {
  const labels: Record<string, string> = {
    SKILL: 'Skill Files',
    PROMPT: 'Prompt Templates',
    CONFIG: 'Configurations',
    WORKFLOW: 'Workflows',
    OTHER: 'Other',
  }
  return labels[category] || category
}

export function getCategoryLabelShort(category: string): string {
  const labels: Record<string, string> = {
    SKILL: 'Skill',
    PROMPT: 'Prompt',
    CONFIG: 'Config',
    WORKFLOW: 'Workflow',
    OTHER: 'Other',
  }
  return labels[category] || category
}
